export default __webpack_public_path__ + "static/media/intro.c6afff54.jpg";